<template>
  <div class="textarea-box">
    <div class="content-title">
      {{ title }}
    </div>
    <textarea :value="value" :placeholder="placeholder" :maxlength="maxlength" @input="onInput"/>
    <div class="counter">
      {{ value.length }} / {{ maxlength }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Textarea-box',
    props: {
      title:  {
        type: String,
        default: '留言'
      },
      placeholder: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      maxlength: {
        type: Number,
        default: 100
      }
    },
    methods: {
      onInput(e) {
        this.$emit("input",e.target.value);
      }
    }
  }
</script>

<style scoped>
  .textarea-box {
    padding: 0.2rem;
    background-color: white;
    width: 94vw;
    margin: 0.2rem 3vw 0;
    border-radius: 0.3rem;
  }
    textarea {
      width: 100%;
      min-height: 2rem;
      max-height: 3rem;
      line-height: 0.4rem;
      color: #595a5a;
    }
    .counter {
      text-align: right;
      margin-right: 0.2rem;
    }
</style>